import dynamic from "next/dynamic";
import CarouselAssetConfig from "./carousel-asset-config";
import CarouselAssetAdvancedConfig from "./carousel-asset-advanced-config";
const CarouselAssetComponent = dynamic(()=>import("./carousel-asset-component"));
export default {
    CarouselAssetComponent,
    CarouselAssetConfig,
    CarouselAssetAdvancedConfig
};
